<template>
    <span>
        <v-badge :value="filterCount > 0" overlap left :content="filterCount" color="primaryText">
            <app-button
                secondary
                icon-left="filter"
                :text="$t('filter')"
                :title="$t('filter')"
                :disabled="disabled"
                @click="showFilterPanel()"
            />
        </v-badge>
    </span>
</template>

<script>
export default {
    name: 'FilterButton',
    props: {
        filterPanelId: {
            type: String,
            required: true
        },
        headers: {
            type: Array,
            default: () => []
        },
        requestItems: {
            type: Function,
            default: () => () => {}
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        filterCount() {
            return this.$store.getters['filterPanels/filterCount'](this.filterPanelId);
        }
    },
    watch: {
        filterPanelId() {
            this.setFilterPanel();
        },
        headers() {
            this.setFilterPanel();
        }
    },
    async mounted() {
        await this.setFilterPanel();

        this.$root.$on(`AppFilterPanels/${this.filterPanelId}/applyFilters`, filters => {
            this.$emit('apply-filters', filters);
        });

        this.$root.$on(`AppFilterPanels/${this.filterPanelId}/clearFilters`, async () => {
            this.$emit('clear-filters');
        });

        this.$emit('load');
    },
    methods: {
        async setFilterPanel() {
            await this.$store.dispatch('filterPanels/update', {
                id: this.filterPanelId,
                options: this.headers,
                requestItems: this.requestItems
            });
        },
        async showFilterPanel() {
            await this.$store.dispatch('filterPanels/show', this.filterPanelId);
        }
    }
};
</script>
